module.exports = __webpack_public_path__ + "img/gartek-services-fire-protection-save-time-money.04cd7063.png";